/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getContainerFactoryStyles } from './style';

const FilterOptionsGroupPreivewUnstyled = (props) => {
  const {
    classes: {
      Container,
      ContentContainer,
      EditButton,
      InVisible,
    },
    Content,
    onEdit,
    showPreview,
    i18nLegacy,
  } = props;

  const onEditHandler = () => {
    onEdit();
  };

  const renderContent = () => Content.map((item, index) => {
    const { key, operator, value } = item;

    if (index + 1 !== Content.length) {
      return <div key={key} className="PreviewItem">{`${key} ${operator} ${value} &`}</div>;
    }
    return <div key={key} className="PreviewItem">{`${key} ${operator} ${value}`}</div>;
  });

  return (
    <div className={showPreview ? Container : InVisible} id="FilterOptionsGroupPreivew">
      <div className={ContentContainer}>
        {renderContent()}
      </div>
      <a
        role="button"
        tabIndex={0}
        className={EditButton}
        onClick={onEditHandler}
        onKeyDown={onEditHandler}
      >
        {i18nLegacy.getString('ShoppingCampaign_Edit')}
      </a>
    </div>
  );
};

FilterOptionsGroupPreivewUnstyled.propTypes = {
  classes: PropTypes.shape(mapObject(
    getContainerFactoryStyles(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  onEdit: PropTypes.func.isRequired,
  Content: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    operator: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  showPreview: PropTypes.bool,
  i18nLegacy: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

FilterOptionsGroupPreivewUnstyled.defaultProps = {
  showPreview: false,
};

const FilterOptionsGroupPreivew =
  withDefaultStyles(FilterOptionsGroupPreivewUnstyled, getContainerFactoryStyles);

export {
  FilterOptionsGroupPreivew,
};

